import React, { createContext, useState, useContext } from "react";

export const NotificationsContext = createContext();

export function NotificationsProvider({ children }) {
	const [notificheCount, setNotificheCount] = useState(0);

	const updateNotificheCount = newCount => {
		setNotificheCount(newCount);
	};

	return (
		<NotificationsContext.Provider value={{ notificheCount, updateNotificheCount }}>
			{children}
		</NotificationsContext.Provider>
	);
}

export function useNotifications() {
	const context = useContext(NotificationsContext);
	if (!context) {
		throw new Error("useNotifications deve essere usato all'interno di NotificationsProvider");
	}
	return context;
}
